import { Navigate, Outlet, createBrowserRouter, useParams } from "react-router-dom";
import { Start } from "./sku-in-box/start";
import { Guide } from "./sku-in-box/guide";
import { Checkout } from "./sku-in-box/checkout";
import { Start as AutonomousStart } from "./autonomous/start";
import { Checkout as AutonomousCheckout } from "./autonomous/checkout";
import { Login } from "./login/login";
import { ProtectedView } from "../components/protected-view";
import { Zones } from "./zones/zones";
import { Recipe } from "./recipe/recipe";
import { RecipeZone } from "./recipe/recipe-zone";
import { Stores } from "./stores/stores";
import { ZoneLayout } from "./zone-layout";
import {
  AutonomousCheckoutProvider,
  SkuInBoxCheckoutProvider,
} from "../components/checkout/checkout-context";
import { MobileAppCheckout } from "./mobile-app-checkout";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <ProtectedView />,
    children: [
      {
        path: "stores",
        element: <Stores />,
      },
      {
        path: "stores/:storeKey",
        element: <Outlet />,
        children: [
          {
            index: true,
            element: <Zones />,
          },

          {
            path: "zones/:zoneId",
            element: <ZoneLayout />,
            children: [
              {
                path: "sku-in-box",
                children: [
                  {
                    index: true,
                    element: <Start />,
                  },
                  {
                    path: "checkout",
                    element: <Start />,
                  },
                  {
                    path: "guide",
                    element: <Guide />,
                  },
                  {
                    path: "checkout/:key",
                    element: (
                      <SkuInBoxCheckoutProvider>
                        <Checkout />
                      </SkuInBoxCheckoutProvider>
                    ),
                  },
                ],
              },
              {
                path: "autonomous",
                children: [
                  {
                    index: true,
                    element: <AutonomousStart />,
                  },
                  {
                    path: "checkout",
                    element: (
                      <AutonomousCheckoutProvider>
                        <AutonomousCheckout />
                      </AutonomousCheckoutProvider>
                    ),
                  },
                ],
              },
              {
                path: "mobile-app",
                children: [
                  {
                    index: true,
                    element: <MobileAppCheckout />,
                  },
                ],
              },
              {
                // Legacy path redirect
                path: "checkout/:key",
                element: <Redirect />,
              },
            ],
          },

          {
            path: "recipe",
            element: <RecipeZone />,
          },
          {
            path: "recipe/:zoneId",
            element: <Recipe />,
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
]);

function Redirect() {
  const { key = "", zoneId = "", storeKey = "" } = useParams();

  return <Navigate to={`/stores/${storeKey}/zones/${zoneId}/sku-in-box/checkout/${key}`} replace />;
}
